import { MenuItem } from 'primeng/api';
import { HelpService } from '../../help/help.service';

/** Item do menu com o módulo (role) do auth-service que libera o acesso a ele. */
export type ItemMenu = MenuItem & { role?: string; items?: ItemMenu[] };

/**
 * Seções do menu controladas pelos perfis do usuário. Cada `role` é o nome de um módulo do
 * auth-service (migration V2__carga_inicial.sql). Ter o módulo de um item libera também os
 * itens abaixo dele.
 */
export function itensPorPerfil(help?: HelpService): ItemMenu[] {
    return [
        {
            label: 'Cadastros',
            role: 'CADASTROS',
            icon: 'pi pi-folder',
            command: () => help?.followMenuCategory('cadastros', 'cadastros'),
            items: [
                {
                    label: 'Corporativo',
                    role: 'CORPORATIVO',
                    icon: 'pi pi-fw pi-briefcase',
                    routerLink: ['/pages/corporativo'],
                    command: () => help?.followMenuCategory('corporativo', 'corporativo-consulta'),
                    items: [
                        { label: 'Região Geográfica', role: 'CORPORATIVO_REGIAO_GEOGRAFICA', icon: 'pi pi-fw pi-map', routerLink: ['/pages/corporativo/regiao-geografica'] },
                        { label: 'Instância', role: 'CORPORATIVO_INSTANCIA', icon: 'pi pi-fw pi-server', routerLink: ['/pages/corporativo/instancia'] },
                        { label: 'Unidade Industrial', role: 'CORPORATIVO_UNIDADE_INDUSTRIAL', icon: 'pi pi-fw pi-warehouse', routerLink: ['/pages/corporativo/unidade-industrial'] },
                        { label: 'Tipo Propriedade', role: 'CORPORATIVO_TIPO_PROPRIEDADE', icon: 'pi pi-fw pi-tags', routerLink: ['/pages/corporativo/tipo-propriedade'] },
                        { label: 'Safra', role: 'CORPORATIVO_SAFRA', icon: 'pi pi-fw pi-sun', routerLink: ['pages/corporativo/safra'] },
                        { label: 'Período', role: 'CORPORATIVO_PERIODO', icon: 'pi pi-fw pi-clock', routerLink: ['pages/corporativo/periodo'] },
                        { label: 'Parâmetros', role: 'CORPORATIVO_PARAMETRO', icon: 'pi pi-fw pi-sliders-h', routerLink: ['/pages/corporativo/parametro'] }
                    ]
                },
                {
                    label: 'Preparação da Safra',
                    role: 'PREPARACAO_SAFRA',
                    icon: 'pi pi-fw pi-wrench',
                    routerLink: ['/pages/preparacao'],
                    command: () => help?.followMenuCategory('preparacao', 'preparacao'),
                    items: [
                        { label: 'Ambiente', role: 'PREPARACAO_SAFRA_AMBIENTE', icon: 'pi pi-fw pi-globe', routerLink: ['/pages/preparacao/ambiente'] },
                        { label: 'Ocupação', role: 'PREPARACAO_SAFRA_OCUPACAO', icon: 'pi pi-fw pi-percentage', routerLink: ['/pages/preparacao/ocupacao'] },
                        { label: 'Característica', role: 'PREPARACAO_SAFRA_CARACTERISTICA', icon: 'pi pi-fw pi-bookmark', routerLink: ['/pages/preparacao/caracteristica'] },
                        { label: 'Variedade', role: 'PREPARACAO_SAFRA_VARIEDADE', icon: 'pi pi-fw pi-palette', routerLink: ['/pages/preparacao/variedade'] },
                        { label: 'Ciclo', role: 'PREPARACAO_SAFRA_CICLO', icon: 'pi pi-fw pi-refresh', routerLink: ['/pages/preparacao/ciclo'] },
                        { label: 'Estágio', role: 'PREPARACAO_SAFRA_ESTAGIO', icon: 'pi pi-fw pi-step-forward', routerLink: ['/pages/preparacao/estagio'] },
                        { label: 'Frente', role: 'PREPARACAO_SAFRA_FRENTE', icon: 'pi pi-fw pi-truck', routerLink: ['/pages/preparacao/frente'] },
                        { label: 'Sistemas de Irrigação', role: 'PREPARACAO_SAFRA_SISTEMAS_IRRIGACAO', icon: 'pi pi-fw pi-cloud', routerLink: ['/pages/preparacao/sistemas-irrigacao'] }
                    ]
                },
                {
                    label: 'Dimensionamento',
                    role: 'DIMENSIONAMENTO',
                    icon: 'pi pi-fw pi-sliders-h',
                    routerLink: ['/pages'],
                    command: () => help?.followMenuCategory('dimensionamento', 'dimensionamento'),
                    items: [
                        { label: 'Área de Fertirrigação', role: 'DIMENSIONAMENTO_AREA_FERTIRRIGACAO', icon: 'pi pi-fw pi-map-marker', routerLink: ['/pages/dimensionamento/area-fertirrigacao'] },
                        { label: 'Variedade Ciclo', role: 'DIMENSIONAMENTO_VARIEDADE_CICLO', icon: 'pi pi-fw pi-table', routerLink: ['/pages/dimensionamento/variedade-ciclo'] },
                        { label: 'Programação Moagem', role: 'DIMENSIONAMENTO_PROGRAMACAO_MOAGEM', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/pages/dimensionamento/programacao-moagem'] }
                    ]
                },
                {
                    label: 'Áreas',
                    role: 'AREAS',
                    icon: 'pi pi-fw pi-map',
                    routerLink: ['/pages/areas'],
                    command: () => help?.followMenuCategory('areas', 'areas-consulta'),
                    items: [
                        { label: 'Fazenda', role: 'AREAS_FAZENDA', icon: 'pi pi-fw pi-home', routerLink: ['/pages/areas/fazenda'] },
                        { label: 'Bloco', role: 'AREAS_BLOCO', icon: 'pi pi-fw pi-th-large', routerLink: ['/pages/areas/bloco'] },
                        { label: 'Talhão', role: 'AREAS_TALHAO', icon: 'pi pi-fw pi-stop', routerLink: ['/pages/areas/talhao'] },
                        { label: 'Bloco de Colheita', role: 'AREAS_BLOCO_COLHEITA', icon: 'pi pi-fw pi-box', routerLink: ['/pages/areas/bloco-colheita'] }
                    ]
                },
                {
                    label: 'Curva de Maturação',
                    role: 'CURVA_MATURACAO',
                    icon: 'pi pi-fw pi-chart-line',
                    command: () => help?.followMenuCategory('curva', 'curva-maturacao'),
                    items: [
                        { label: 'Análise de Integridade', role: 'CURVA_MATURACAO_ANALISE_INTEGRIDADE', icon: 'pi pi-fw pi-verified', routerLink: ['/pages/curva/analise-integridade'] },
                        { label: 'Cálculo Histórico', role: 'CURVA_MATURACAO_CALCULO_HISTORICO', icon: 'pi pi-fw pi-history', routerLink: ['/pages/curva/calculo-historico'] },
                        { label: 'Log de Geração', role: 'CURVA_MATURACAO_LOG_GERACAO', icon: 'pi pi-fw pi-receipt', routerLink: ['/pages/curva/log-geracao'] },
                        { label: 'Cálculo da Curva', role: 'CURVA_MATURACAO_CALCULO_CURVA', icon: 'pi pi-fw pi-calculator', routerLink: ['/pages/curva/calculo-curva'] },
                        { label: 'Visualização do Cálculo', role: 'CURVA_MATURACAO_VISUALIZACAO', icon: 'pi pi-fw pi-eye', routerLink: ['/pages/curva/visualizacao'] },
                        { label: 'Deslocamento', role: 'CURVA_MATURACAO_DESLOCAMENTO', icon: 'pi pi-fw pi-arrows-h', routerLink: ['/pages/curva/deslocamento'] },
                        { label: 'Transferência', role: 'CURVA_MATURACAO_TRANSFERENCIA', icon: 'pi pi-fw pi-arrow-right-arrow-left', routerLink: ['/pages/curva/transferencia'] },
                        { label: 'Dados Teóricos', role: 'CURVA_MATURACAO_DADOS_TEORICOS', icon: 'pi pi-fw pi-book', routerLink: ['/pages/curva/dados-teoricos'] },
                        { label: 'Curva Padrão', role: 'CURVA_MATURACAO_CURVA_PADRAO', icon: 'pi pi-fw pi-wave-pulse', routerLink: ['/pages/curva/curva-padrao'] }
                    ]
                }
            ]
        },
        {
            label: 'Restrições',
            role: 'RESTRICOES',
            icon: 'pi pi-fw pi-ban',
            routerLink: ['/pages'],
            command: () => help?.followMenuCategory('restricoes', 'restricoes'),
            items: [
                { label: 'Grupo de Período', role: 'RESTRICOES_GRUPO_PERIODO', icon: 'pi pi-fw pi-calendar-clock', routerLink: ['/pages/simulacao/restricoes/periodos'] },
                { label: 'Variedade', role: 'RESTRICOES_VARIEDADE', icon: 'pi pi-fw pi-palette', routerLink: ['/pages/simulacao/restricoes/variedades'] },
                { label: 'Agrupamento', role: 'RESTRICOES_AGRUPAMENTO', icon: 'pi pi-fw pi-objects-column', routerLink: ['/pages/simulacao/restricoes/agrupamentos'] },
                { label: 'Bloco de Colheita', role: 'RESTRICOES_BLOCO_COLHEITA', icon: 'pi pi-fw pi-box', routerLink: ['/pages/simulacao/restricoes/grupos-blocos'] },
                { label: 'Fertirrigação', role: 'RESTRICOES_FERTIRRIGACAO', icon: 'pi pi-fw pi-map-marker', routerLink: ['/pages/simulacao/restricoes/fertirrigacoes'] }
            ]
        },
        {
            label: 'Colheitabilidade',
            role: 'COLHEITABILIDADE',
            icon: 'pi pi-chart-scatter',
            routerLink: ['/pages/colheitabilidade'],
            command: () => help?.followMenuCategory('colheitabilidade', 'colheitabilidade'),
            items: [
                { label: 'Cadastros', role: 'COLHEITABILIDADE_CADASTROS', icon: 'pi pi-fw pi-folder-open', routerLink: ['/pages/colheitabilidade/cadastros'] },
                { label: 'Cálculo', role: 'COLHEITABILIDADE_CALCULO', icon: 'pi pi-fw pi-calculator', routerLink: ['/pages/colheitabilidade/calculo'] }
            ]
        },
        {
            label: 'Processos',
            role: 'PROCESSOS',
            icon: 'pi pi-cog',
            command: () => help?.followMenuCategory('processo', 'processos'),
            items: [
                { label: 'Simulações', role: 'PROCESSOS_SIMULACOES', icon: 'pi pi-fw pi-play', routerLink: ['/pages/simulacao'] },
                { label: 'Semanal', role: 'PROCESSOS_SEMANAL', icon: 'pi pi-fw pi-calendar', routerLink: ['/pages/semanal'] },
                { label: 'Alterar Sequenciamento', role: 'PROCESSOS_ALTERAR_SEQUENCIAMENTO', icon: 'pi pi-fw pi-sort-alt', routerLink: ['/pages/processo/alterar-sequenciamento'] },
                { label: 'Análise de Restrições', role: 'PROCESSOS_ANALISE_RESTRICOES', icon: 'pi pi-fw pi-filter', routerLink: ['/pages/processo/analise-restricao'] },
                { label: 'Análise de Dimensionamento', role: 'PROCESSOS_ANALISE_DIMENSIONAMENTO', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/pages/processo/analise-dimensionamento'] },
                { label: 'Análise de Fertirrigação', role: 'PROCESSOS_ANALISE_FERTIRRIGACAO', icon: 'pi pi-fw pi-chart-pie', routerLink: ['/pages/processo/analise-fertirrigacao'] },
                { label: 'Ordem de Colheita', role: 'PROCESSOS_ORDEM_COLHEITA', icon: 'pi pi-fw pi-list-check', routerLink: ['/pages/processo/ordem-colheita'] },
                { label: 'Gerador de Análise', role: 'PROCESSOS_GERADOR_ANALISE', icon: 'pi pi-fw pi-bolt', routerLink: ['/pages/processo/gerar-analise'] }
            ]
        },
        {
            label: 'Importação',
            role: 'IMPORTACAO',
            icon: 'pi pi-upload',
            command: () => help?.followMenuCategory('integracao', 'importacao-visao-geral'),
            items: [{ label: 'Importação / Atualização', role: 'IMPORTACAO_ATUALIZACAO', icon: 'pi pi-fw pi-sync', routerLink: ['/pages/importacao'] }]
        },
        {
            label: 'Relatórios',
            role: 'RELATORIOS',
            icon: 'pi pi-file',
            command: () => help?.followMenuCategory('relatorio', 'relatorios'),
            items: [{ label: 'Relatórios de Simulação', role: 'RELATORIOS_SIMULACAO', icon: 'pi pi-fw pi-file-pdf', routerLink: ['/pages/relatorio'] }]
        },
        {
            label: 'Ajuda',
            role: 'AJUDA',
            icon: 'pi pi-question-circle',
            items: [{ label: 'Central de Ajuda', role: 'AJUDA_CENTRAL', icon: 'pi pi-question-circle', command: () => void help?.open() }]
        }
    ];
}

/**
 * Mantém só os itens liberados pelos roles do usuário. Um item é liberado pelo próprio role ou
 * pelo role de qualquer item acima dele; um grupo sem nenhum filho liberado é removido.
 */
export function filtrarPorRoles(itens: ItemMenu[], roles: ReadonlySet<string>, liberadoPeloPai = false): ItemMenu[] {
    const resultado: ItemMenu[] = [];
    for (const item of itens) {
        const liberado = liberadoPeloPai || (!!item.role && roles.has(item.role));
        if (item.items) {
            const filhos = filtrarPorRoles(item.items, roles, liberado);
            if (filhos.length) resultado.push({ ...item, items: filhos });
        } else if (liberado) {
            resultado.push(item);
        }
    }
    return resultado;
}

/** Tela do menu (link de um item sem filhos) e os roles que a liberam: o do item e os dos itens acima dele. */
type Tela = { link: string; roles: string[] };

function telas(itens: ItemMenu[], rolesAcima: string[] = []): Tela[] {
    return itens.flatMap(item => {
        const roles = item.role ? [...rolesAcima, item.role] : rolesAcima;
        if (item.items) return telas(item.items, roles);
        const link = Array.isArray(item.routerLink) ? item.routerLink[0] : item.routerLink;
        return typeof link === 'string' ? [{ link: '/' + link.replace(/^\/+/, ''), roles }] : [];
    });
}

const TELAS = telas(itensPorPerfil()).sort((a, b) => b.link.length - a.link.length);

/**
 * Roles que liberam a URL, pela tela do menu mais específica que a contém
 * (ex.: /pages/simulacao/restricoes/periodos/novo → Grupo de Período). Null se a URL não é de uma tela do menu.
 */
export function rolesDaUrl(url: string): string[] | null {
    const caminho = url.split(/[?#]/)[0].replace(/\/+$/, '');
    return TELAS.find(tela => caminho === tela.link || caminho.startsWith(tela.link + '/'))?.roles ?? null;
}
